import scopeLogger from '../../lib/scope-logger';
import { normalizeCreativeName } from '../../utils/formatters';

const console = scopeLogger('RMI:Renderers');

class Renderer {
  #locked = false;
  #allowed = false;
  #name;
  #test;

  constructor(name, extension) {
    this.#name = normalizeCreativeName(name);
    this.#test = extension.test;
    this.#allowed = extension.allowed;
  }

  get name() {
    return this.#name;
  }

  get locked() {
    return this.#locked;
  }

  get allowed() {
    return this.#allowed;
  }

  set allowed(newState) {
    this.#allowed = newState;
  }

  set locked(newState) {
    if (newState) {
      console.log(`set ${this.#name} locked`);
    } else {
      console.log(`set ${this.#name} unlocked`);
    }
    this.#locked = newState;
  }

  test(creative) {
    return this.#test ? this.#test(creative) : false;
  }
}

export default class RenderersRegistry {
  #registry = new Map();

  register(name, extension) {
    this.#registry.set(
      normalizeCreativeName(name),
      new Renderer(name, extension),
    );
  }

  getRenderer(creative) {
    const renderer = Array.from(this.#registry.values()).find((renderer) =>
      renderer.test(creative),
    );
    if (!renderer) {
      console.warn('no renderer found for', creative);
    }

    if (renderer && !renderer.allowed) {
      console.warn('rendered found, but not allowed', creative);
    }

    return renderer;
  }

  update(extensions) {
    extensions.forEach((extension) => {
      const registry = this.#registry.get(
        normalizeCreativeName(extension.name),
      );
      if (registry) registry.allowed = extension.allowed;
    });
  }
}
